import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const room = target => (Number.isFinite(target.maxHp) && Number.isFinite(target.currentHp) ? Math.max(0, target.maxHp - target.currentHp) : Infinity);

/** Each recipient filled in order, until the pool runs out. */
export const fillEveryone = (targets, total) => {
  let left = total;
  return Object.fromEntries(targets.map(target => { const amount = Math.min(room(target), left); left -= amount; return [target.id, amount]; }));
};
export const splitEvenly = (targets, total) => Object.fromEntries(targets.map(target => [target.id, Math.min(room(target), Math.floor(total / targets.length))]));

/** Mass Heal: the caster divides the Hit Points among the chosen creatures. Leftover Hit Points are lost. */
export default function MassHealAllocation({ total, targets, onCast, onCancel }) {
  const [amounts, setAmounts] = useState(() => fillEveryone(targets, total)), [error, setError] = useState('');
  const used = Object.values(amounts).reduce((sum, value) => sum + value, 0);
  const set = (target, value) => {
    const others = used - amounts[target.id], cap = Math.min(room(target), total - others);
    const amount = Math.max(0, Math.min(cap, Math.round(Number(value) || 0)));
    setError(Number(value) > cap ? `${target.name} can take ${cap}.` : '');
    setAmounts(old => ({ ...old, [target.id]: amount }));
  };
  const pick = next => { setError(''); setAmounts(next); };
  return <Modal show centered onHide={onCancel} className="dnd-modal modern-modal" aria-label="Mass Heal">
    <Modal.Header><Modal.Title>Mass Heal</Modal.Title><span className="ms-auto"><strong>{total - used}</strong> of {total} left</span></Modal.Header>
    <Modal.Body>
      {targets.map(target => <div key={target.id} className="d-flex align-items-center gap-2 mb-2">
        <div style={{ width: 110 }}><strong className="d-block text-truncate">{target.name}</strong>
          {Number.isFinite(target.currentHp) && <small>{target.currentHp} → {target.currentHp + amounts[target.id]}{Number.isFinite(target.maxHp) ? ` / ${target.maxHp}` : ''}</small>}</div>
        <Form.Range aria-label={`${target.name} healing`} min={0} max={Number.isFinite(room(target)) ? room(target) : total} value={amounts[target.id]} onChange={event => set(target, event.target.value)} />
        <Form.Control aria-label={`${target.name} amount`} type="number" min={0} style={{ width: 84 }} value={amounts[target.id]} onChange={event => set(target, event.target.value)} />
      </div>)}
      <div className="d-flex gap-2 mt-2">
        <Button size="sm" variant="secondary" onClick={() => pick(fillEveryone(targets, total))}>Fill everyone</Button>
        <Button size="sm" variant="secondary" onClick={() => pick(splitEvenly(targets, total))}>Split evenly</Button>
        <Button size="sm" variant="secondary" onClick={() => pick(Object.fromEntries(targets.map(target => [target.id, 0])))}>Clear</Button>
      </div>
      {error && <p role="alert" className="text-danger small mt-2 mb-0">{error}</p>}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel}>Back</Button>
      <Button disabled={!used} onClick={() => onCast(amounts)}>Cast Mass Heal</Button>
    </Modal.Footer>
  </Modal>;
}
